import { render, staticRenderFns } from "./PdfEditing.vue?vue&type=template&id=0baa93fd"
import script from "./PdfEditing.vue?vue&type=script&lang=js"
export * from "./PdfEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports